angular.module 'zc.master.zcliteProjectsForReview'

.config ($stateProvider) ->
  $stateProvider
  .state 'admin.master.zcliteProjectsForReview',
    url: '/zclite_projects_for_review'
    views:
      'content@':
        templateUrl: '/templates/master.zclite_projects_for_review/list.html'
        controller: 'MasterZcliteProjectsListForReviewCtrl'



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_projects_for_review/routes.coffee